<template>

  <div id="aap_jury">

    <dlnkmessages-new-message
        :member_id="0"
        :member_name="0"
        :subject="notification_subject"
        :group_id="''">
    </dlnkmessages-new-message>

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <dlnkwait :wait_data="wait_data"></dlnkwait>


    <div v-if="admin" class="container space-top-1 space-top-sm-2 space-bottom-2">
      <div class="d-none d-lg-block row justify-content-center mx-0 pl-7 mb-4">
        <!-- Step -->
        <ul class="step step-md step-border-last-0 flex-grow-1 my-3">

          <li class="step-item">
            <div class="step-content-wrapper">
              <span class="step-icon step-icon-primary">1</span>
              <div class="step-content">
                <h5>Instruction <br>du dossier</h5>
              </div>
            </div>
          </li>

          <li class="step-item">
            <div class="step-content-wrapper">
              <span class="step-icon step-icon-soft-primary">2</span>
              <div class="step-content">
                <h5>Comité technique <br>du projet</h5>
              </div>
            </div>
          </li>

          <li class="step-item">
            <div class="step-content-wrapper">
              <span class="step-icon step-icon-soft-primary">3</span>
              <div class="step-content">
                <h5>Soumis au vote</h5>
              </div>
            </div>
          </li>

          <li class="step-item">
            <div class="step-content-wrapper">
              <span class="step-icon step-icon-soft-primary">4</span>
              <div class="step-content">
                <h5>Projet en attente <br>de validation</h5>
              </div>
            </div>
          </li>
        </ul>
        <!-- End Step -->
      </div>

      <div class="row">
        <div id="stickyBlockStartPoint" class="col-md-5 col-lg-4 mb-7 mb-md-0" style="z-index: 100">
          <div class="js-sticky-block card card-bordered p-4"
               data-hs-sticky-block-options='{
                 "parentSelector": "#stickyBlockStartPoint",
                 "breakpoint": "md",
                 "startPoint": "#stickyBlockStartPoint",
                 "endPoint": "#stickyBlockEndPoint",
                 "stickyOffsetTop": 50,
                 "stickyOffsetBottom": 12
               }'>
            <div class="text-center">
              <!-- User Content -->
              <img class="img-fluid rounded-circle mx-auto" :src="aap.logo_structure || '/modules/dlnkaap/img/company.png' "
                   alt="Image Description" style="height: 120px; width: auto;">

              <!--Nom de la structure-->
              <h3 class="mb-0">
                {{ aap.nom }}
              </h3>
              <!--Nom du projet-->
              <span class="d-block text-body font-size-1 my-2">
                {{ aap.projet_nom }}
              </span>

              <hr>

              <h3 class="text-muted">{{ aap.axe }}</h3>
              <ul class="text-left text-muted">
                <li v-for="tag in aap.tags" :key="tag.id">{{ tag.nom }}</li>
              </ul>

              <p>Date de dernière mise à jour :
                <br>
                <span class="font-weight-bold">{{ aap.maj }}</span>
              </p>

              <div class="row mt-2">
                <div class="col-6 pr-1">
<!--                  <a class="btn btn-sm btn-outline-primary btn-block transition-3d-hover"-->
<!--                     :href="'mailto:' + aap.contact_email">-->
<!--                    <i class="far fa-envelope"></i>-->
<!--                    Envoyer <br> un mail-->
<!--                  </a>-->

                  <button type="button" id="new_message" class="btn btn-sm btn-primary btn-block transition-3d-hover"
                          data-tooltip="tooltip" title="Envoyer un message" @click="notification_subject = '[ZeLink] - Message de la part du département'"
                          data-toggle="modal" data-target="#new_message_modal">
                        <span>
                            <i class="far fa-envelope" aria-hidden="true"></i> &nbsp;
                            Envoyer un message
                        </span>
                  </button>
                </div>
                <div class="col-6 pl-1">
                  <a class="btn btn-sm btn-primary btn-block transition-3d-hover"
                     :href="'/module/dlnkaap/formulaire_pdf?aap_id=' + aap.id">
                    <i class="fa fa-file"></i>
                    Candidature <br> porteur (pdf)
                  </a>
                </div>
              </div>

              <div v-if="other_projects.length > 1" class="btn-group btn-block mt-2" >
                <button type="button" class="btn btn-outline-primary dropdown-toggle" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                  Autres projets de la structure
                </button>
                <div class="dropdown-menu">
                  <a v-if="aap.id != other_project.id" v-for="other_project in other_projects" :key="other_project.id" class="dropdown-item">{{other_project.projet_nom}} ({{other_project.subvention_sollicitee}} €)
                    <a :href="'/module/dlnkaap/jury_extraction?id=' + other_project.id" class="btn btn-light btn-scale font-size-1 ml-1"
                       data-tooltip="tooltip" title="Jury">
                      <i class="fas fa-gavel fa-fw"></i>
                    </a>
                    <a class="btn btn-light btn-scale font-size-1 ml-1" data-tooltip="tooltip" title="Visualiser le PDF"
                       :href="'/module/dlnkaap/formulaire_pdf?aap_id=' + other_project.id">
                      <i class="fas fa-file-pdf fa-fw"></i>
                    </a>
                  </a>
                </div>
              </div>

              <div class="my-2">
                <a class="btn btn-primary btn-block transition-3d-hover"
                   href="/module/dlnkaap/liste_reponses_porteur">
                  <i class="fa fa-arrow-left"></i>
                  Retour liste candidatures
                </a>
              </div>
              <!-- End User Content -->
            </div>

            <div class="border-top pt-3">
              <div class="d-flex justify-content-center flex-wrap">

                <div class="form-group">
                    Statut&nbsp;:

                  <select :id="'status_id_' + aap.id" v-model="statusValue"
                            name="aap[aap_status_histories_attributes][0][status_id]">
                      <option v-for="status in statuses" :key="status.id"
                              :value="status.id" :selected="status.name == aap.status ? true : false">
                        {{ status.name }}
                      </option>
                    </select>
                </div>


                <ul>
                  <li class="text-left">Montant global du projet : <span class="font-italic text-muted">{{ aap.budget_global }} €</span></li>
                  <li class="">Montant de la subvention sollicitée : <span class="font-italic text-muted">{{ aap.subvention_sollicitee }} €</span></li>
                  <li class="">Montant proposé : <span class="font-italic text-muted">{{ montant_propose }} €</span></li>
                  <li class="">Montant décidé ({{ avis_comite }}) : <span class="font-italic text-muted">{{ montant_decide }} €</span></li>
                  <li class="">Montant attribué : <span class="font-italic text-muted">{{ montant_attribue }} €</span></li>
                </ul>


              </div>
            </div>
          </div>
        </div>

        <div class="col-md-7 col-lg-8">

            <div class="card">

              <div class="card-body">

                <h3 class="text-left text-primary">Résumé du projet</h3>
                <p>
                  {{ aap.presentation }}
                </p>


                <div>
                  <!-- Courses -->
                  <div class="border-top border-3 pt-2 mt-4">
                    <div class="d-flex align-items-center justify-content-start mb-2">
                      <h3 class="text-left text-primary mb-0">Données du projet</h3>
                    </div>
                  </div>
                  <!-- End Courses -->

                  <h5>
                    Liste des communes touchées
                  </h5>
                  <ul class="two-column-md three-column-lg">
                    <li v-for="commune in aap.communes" :key="commune.id">
                      {{ commune.nom }}
                    </li>
                  </ul>
                  <h5>
                    QPV
                  </h5>

                  <ul class="two-column-md">
                    <li v-for="quartier in aap.quartiers" :key="quartier.id">
                      {{ quartier.nom }}
                    </li>
                  </ul>

                  <h4>Objectif global</h4>
                  <p class="text-muted font-size-1">
                    {{ aap.projet_objectif }}
                  </p>

                  <h5>
                    Objectifs
                  </h5>
                  <div class="row">
                    <div class="col-12 col-md-6 p-1" v-for="objectif in aap.objectifs">
                      <div class="card bg-soft-primary p-2">
                        <h5>{{ objectif.objectif }}</h5>
                        <h6>Description</h6>
                        <p>
                          {{ objectif.description }}
                        </p>
                        <h6>Risques</h6>
                        <p>
                          {{ objectif.risque }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <h5>
                    Public cible
                  </h5>

                  <div class="p-3">
                    <table class="table table-striped table-bordered">
                      <thead class="">
                      <tr>
                        <th scope="col" style="width: 14.3%">
                          <span class="text-success float-right">Age</span>
                          <br>
                          <span class="text-primary">Genre</span>
                        </th>
                        <th class="text-center text-success" scope="col" style="vertical-align: top; width: 14.3%">- de 3 ans</th>
                        <th class="text-center text-success" scope="col" style="vertical-align: top; width: 14.3%">4-10</th>
                        <th class="text-center text-success" scope="col" style="vertical-align: top; width: 14.3%">11-17</th>
                        <th class="text-center text-success" scope="col" style="vertical-align: top; width: 14.3%">18-24</th>
                        <th class="text-center text-success" scope="col" style="vertical-align: top; width: 14.3%">25-65</th>
                        <th class="text-center text-success" scope="col" style="vertical-align: top; width: 14.3%">+ de 65 ans</th>
                        <th class="text-center text-success" scope="col" style="vertical-align: top; width: 14.3%">Total genre</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <th class="text-primary" scope="row">Femmes</th>
                        <td class="text-center">{{ aap.femmes_tranche_1 }}</td>
                        <td class="text-center">{{ aap.femmes_tranche_2 }}</td>
                        <td class="text-center">{{ aap.femmes_tranche_3 }}</td>
                        <td class="text-center">{{ aap.femmes_tranche_4 }}</td>
                        <td class="text-center">{{ aap.femmes_tranche_5 }}</td>
                        <td class="text-center">{{ aap.femmes_tranche_6 }}</td>
                        <td class="text-center">{{  parseInt(aap.femmes_tranche_1,10)
                        + parseInt(aap.femmes_tranche_2,10)
                        + parseInt(aap.femmes_tranche_3,10)
                        + parseInt(aap.femmes_tranche_4,10)
                        + parseInt(aap.femmes_tranche_5,10)
                        + parseInt(aap.femmes_tranche_6,10)  }}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-primary" scope="row">Hommes</th>
                        <td class="text-center">{{ aap.hommes_tranche_1 }}</td>
                        <td class="text-center">{{ aap.hommes_tranche_2 }}</td>
                        <td class="text-center">{{ aap.hommes_tranche_3 }}</td>
                        <td class="text-center">{{ aap.hommes_tranche_4 }}</td>
                        <td class="text-center">{{ aap.hommes_tranche_5 }}</td>
                        <td class="text-center">{{ aap.hommes_tranche_6 }}</td>
                        <td class="text-center">{{  parseInt(aap.hommes_tranche_1,10)
                        + parseInt(aap.hommes_tranche_2,10)
                        + parseInt(aap.hommes_tranche_3,10)
                        + parseInt(aap.hommes_tranche_4,10)
                        + parseInt(aap.hommes_tranche_5,10)
                        + parseInt(aap.hommes_tranche_6,10)  }}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-primary" scope="row">Total age</th>
                        <td class="text-center">{{  parseInt(aap.femmes_tranche_1,10) + parseInt(aap.hommes_tranche_1,10) }}</td>
                        <td class="text-center">{{  parseInt(aap.femmes_tranche_2,10) + parseInt(aap.hommes_tranche_2,10) }}</td>
                        <td class="text-center">{{  parseInt(aap.femmes_tranche_3,10) + parseInt(aap.hommes_tranche_3,10) }}</td>
                        <td class="text-center">{{  parseInt(aap.femmes_tranche_4,10) + parseInt(aap.hommes_tranche_4,10) }}</td>
                        <td class="text-center">{{  parseInt(aap.femmes_tranche_5,10) + parseInt(aap.hommes_tranche_5,10) }}</td>
                        <td class="text-center">{{  parseInt(aap.femmes_tranche_6,10) + parseInt(aap.hommes_tranche_6,10) }}</td>
                        <td class="text-center">{{  parseInt(aap.hommes_tranche_1,10)
                        + parseInt(aap.hommes_tranche_2,10)
                        + parseInt(aap.hommes_tranche_3,10)
                        + parseInt(aap.hommes_tranche_4,10)
                        + parseInt(aap.hommes_tranche_5,10)
                        + parseInt(aap.hommes_tranche_6,10)
                        + parseInt(aap.femmes_tranche_1,10)
                        + parseInt(aap.femmes_tranche_2,10)
                        + parseInt(aap.femmes_tranche_3,10)
                        + parseInt(aap.femmes_tranche_4,10)
                        + parseInt(aap.femmes_tranche_5,10)
                        + parseInt(aap.femmes_tranche_6,10)}}
                        </td>

                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="ml-3">
                    <h5 class="mt-2">Typologie public</h5>

                    <div class="row">
                      <ul class="text-muted font-size-1 two-column-md">
                        <li v-for="pub in aap.publics" :key="pub.id">{{ pub.nom }}</li>
                      </ul>
                    </div>
                  </div>

                  <div v-if="aap.actions_recentes" class="my-2">
                    <h4 class="mb-3">Les projets des 2 dernières années</h4>
                    <h5>Description</h5>
                    <p class="text-muted font-size-1">
                      {{ aap.actions_recentes_description }}
                    </p>
                    <h5>Financeurs</h5>
                    <p class="text-muted font-size-1">
                      {{ aap.financeur_recent }}
                    </p>
                    <h5 v-if="aap.coporte_recent">Expertise complémentaire</h5>
                    <p class="text-muted font-size-1">
                      {{ aap.coporte_recent_description }}
                    </p>
                  </div>

                  <div class="card p-4 my-2">
                    <div class="card-header p-0">
                      <h5>Budget</h5>
                    </div>
                    <div class="card-body">
                      <h3 class="text-center">Montant global du projet : <span
                          class="font-italic text-muted">{{ aap.budget_global }} €</span>
                      </h3>
                      <h3 class="text-center">Montant de la subvention sollicitée : <span
                          class="font-italic text-muted">{{ aap.subvention_sollicitee }} €</span>
                      </h3>
                    </div>
                  </div>
                </div>


              </div>


          </div>

            <div class="border-top border-3 pt-3 mt-4">

              <div class="card mt-3" id="action_content">

                <div class="card-header py-3" v-bind:class="{'bg-grey' : statusValue > 1}">
                  <h5 class="mb-0">
                    <button class="btn btn-link btn-block text-left pl-0" style="font-size: 1rem !important;" @click="collapsed = !collapsed"
                            data-toggle="collapse" data-target="#action_content_00" aria-expanded="true" aria-controls="collapse">
                      <i v-if="collapsed" class="fa fa-plus pr-2" aria-hidden="true"></i>
                      <i v-else class="fa fa-minus pr-2" aria-hidden="true"></i>
                      Suivi du dossier
                    </button>
                  </h5>
                </div>

                <div class="card-body px-2 py-3 collapse" id="action_content_00">

                  <div class="card-body border-bottom pb-0">

                    <div class="row my-3">
                      <h5 class="col-6">Date comité technique&nbsp;: </h5>
                      <h5 class="text-muted">{{ comite_technique.date_comite_technique_fr }}</h5>
                    </div>
                    <div class="row mb-3">
                      <h5 class="col-6">Date de commission&nbsp;: </h5>
                      <h5 class="text-muted">{{commission.date_commission_fr}}</h5>
                    </div>
                    <div class="row my-3">
                      <h5 class="col-6">Nomenclature&nbsp;: </h5>
                      <h5 class="text-muted">{{ aap.axe }}</h5>
                    </div>
                  </div>

                  <div class="card-body border-bottom pb-0">
                    <div class="row my-3">
                      <h5 class="col-6">Référent : </h5>
                      <h5 class="text-muted">{{ referent.name }}</h5>
                    </div>
<!--                    <div class="row my-3">-->
<!--                      <h5 class="col-6">Chargé de mission : </h5>-->
<!--                      <h5 class="text-muted">{{ charge_mission.name }}</h5>-->
<!--                    </div>-->
                    <!--                  <div class="row my-3">-->
                    <!--                    <h5 class="col-6 align-self-center mb-0">Elus</h5>-->
                    <!--                    <select class="custom-select col-6">-->
                    <!--                      <option v-for="elu in elus">{{ elu }}</option>-->
                    <!--                    </select>-->
                    <!--                  </div>-->
                  </div>

                  <div class="card-body border-bottom" style="border-bottom-width: 0.25rem !important">
                    <div class="row my-3">
                      <h5 class="col-6">Montants accordés précédents </h5>
                      <h5 v-if="!aap.has_previous_proj" class="text-muted">Premier projet</h5>
                      <div v-if="aap.has_previous_proj" class="col-6">
                        <div class="col-12">
                          <span class="h5">N-2 : </span>
                          <span class="h5 text-muted">{{ aap.montant_alloue_N2 }} €</span>
                        </div>
                        <div class="col-12">
                          <span class="h5">N-1 : </span>
                          <span class="h5 text-muted">{{ aap.montant_alloue_N1 }} €</span>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex w-100 justify-content-center">
                      <a class="btn btn-primary d-flex align-items-center" href="javascript:;" role="button"
                         data-toggle="modal" data-target="#modal_instruction">
                        <span style="font-size: 1.1rem"><i class="fa fa-arrow-right mr-2" aria-hidden="true"></i>Saisir les données</span>
                      </a>
                    </div>

                    <div class="modal fade" id="modal_instruction" tabindex="-1" role="dialog"
                         aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog" role="document" style="max-width: 40%">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">Instruction du dossier</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <form id="instruction_form" @submit.prevent="post_instruction(aap.id)">
                            <div class="modal-body">

                              <!--                            Comité technique-->
                              <div class="row form-group">
                                <label for="aap_comite_technique_id" class="col-sm-5 col-form-label input-label">
                                  Date de comité technique
                                </label>
                                <div class="col-sm-7">
                                  <div class="input-group">
                                    <select id="aap_comite_technique_id" name="aap[comite_technique_id]" class="form-control" v-model="comite_technique.id">
                                      <option value="0">
                                        Date de comité technique
                                      </option>
                                      <option v-for="comite in comite_techniques" :key="comite.id" :value="comite.id">
                                        {{ comite.date_comite_technique_fr }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <!--                            Comission-->
                              <div class="row form-group">
                                <label for="aap_commission_id" class="col-sm-5 col-form-label input-label">
                                  Date de commission
                                </label>
                                <div class="col-sm-7">
                                  <div class="input-group">
                                    <select id="aap_commission_id" name="aap[commission_id]" class="form-control" v-model="commission.id">
                                      <option value="0">
                                        Date de commission
                                      </option>
                                      <option v-for="comm in commissions" :key="comm.id" :value="comm.id">
                                        {{ comm.date_commission_fr }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <!--                            Référent-->
                              <div class="row form-group">
                                <label for="aap_referent_id" class="col-sm-5 col-form-label input-label">
                                  Référent
                                </label>
                                <div class="col-sm-7">
                                  <div class="input-group">
                                    <select id="aap_referent_id" name="aap[referent_id]" class="form-control" v-model="referent.id">
                                      <option value="0">Référent</option>
                                      <option v-for="ref in referents" :key="ref.id" :value="ref.id">
                                        {{ ref.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <!--                            Chargé de mission-->
<!--                              <div class="row form-group">-->
<!--                                <label for="aap_charge_mission_id" class="col-sm-5 col-form-label input-label">-->
<!--                                  Chargé de mission-->
<!--                                </label>-->
<!--                                <div class="col-sm-7">-->
<!--                                  <div class="input-group">-->
<!--                                    <select id="aap_charge_mission_id" name="aap[charge_mission_id]" class="form-control" v-model="charge_mission.id">-->
<!--                                      <option value="0">Chargé de mission</option>-->
<!--                                      <option v-for="charge in charge_missions" :key="charge.id"-->
<!--                                              :value="charge.id">-->
<!--                                        {{ charge.name }}-->
<!--                                      </option>-->
<!--                                    </select>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->

                              <!--                            Nomenclature-->
                              <div class="row form-group">
                                <label for="aap_axe" class="col-sm-5 col-form-label input-label">
                                  Nomenclature
                                </label>
                                <div class="col-sm-7">
                                  <div class="input-group">
                                    <select name="aap[axe]" id="aap_axe" class="form-control" >
                                      <option value="" :selected="aap.axe == '' ? true : false">Nomenclature</option>
                                      <option value="Autonomie (Handicap et Senior)" :selected="aap.axe == 'Autonomie (Handicap et Senior)' ? true : false">Autonomie (Handicap et Senior)</option>
                                      <option value="Famille / Jeunesse" :selected="aap.axe == 'Famille / Jeunesse' ? true : false">Famille / Jeunesse</option>
                                      <option value="Insertion et action sociale" :selected="aap.axe == 'Insertion et action sociale' ? true : false">Insertion et action sociale</option>
                                      <option value="Logement et mixité sociale" :selected="aap.axe == 'Logement et mixité sociale' ? true : false">Logement et mixité sociale</option>
                                      <option value="Santé et petite enfance" :selected="aap.axe == 'Santé et petite enfance' ? true : false">Santé et petite enfance</option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div class="row form-group">
                                <label class="col-sm-5 col-form-label input-label">Projet précédent ?</label>
                                <div class="d-flex align-items-center">
                                  <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="previous_proj" class="custom-control-input" :value="true" v-model="has_previous_proj">
                                    <label class="custom-control-label" for="previous_proj">Oui</label>
                                  </div>
                                  <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="no_previous_proj"  class="custom-control-input" :value="false" v-model="has_previous_proj">
                                    <label class="custom-control-label" for="no_previous_proj">Non</label>
                                  </div>
                                </div>
                              </div>

                              <div v-if="has_previous_proj" class="row form-group">
                                <label class="col-sm-5 col-form-label input-label">Montants accordés précédents</label>

                                <div class="col-sm-7">
                                  <div class="col-12 form-group row">
                                    <label for="aap_montant_alloue_N2" class="col-sm-4 col-form-label input-label">N-2</label>
                                    <input type="text" class="form-control col-sm-8" name="aap[montant_alloue_N2]" id="aap_montant_alloue_N2">
                                  </div>
                                  <div class="col-12 form-group row">
                                    <label for="aap_montant_alloue_N1" class="col-sm-4 col-form-label input-label">N-1</label>
                                    <input type="text" class="form-control col-sm-8" name="aap[montant_alloue_N1]" id="aap_montant_alloue_N1">
                                  </div>
                                </div>
                              </div>

                            </div>
                            <div class="modal-footer">
                              <button type="submit" class="btn btn-primary" data-dismiss="modal">Annuler</button>
                              <button type="submit" class="btn btn-primary">Sauvegarder</button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div v-if="statusValue > 2" class="card-header py-3"
                     v-bind:class="{'bg-grey' : statusValue > 1}">
                  <h5 class="mb-0">
                    <button class="btn btn-link btn-block text-left pl-0" style="font-size: 1rem !important;" @click="collapsed0 = !collapsed0"
                            data-toggle="collapse" data-target="#action_content_0" aria-expanded="true" aria-controls="collapseOne">
                      <i v-if="collapsed0" class="fa fa-plus pr-2" aria-hidden="true"></i>
                      <i v-else class="fa fa-minus pr-2" aria-hidden="true"></i>
                      Complétude dossier
                    </button>
                  </h5>
                </div>

                <div class="card-body px-2 py-3 collapse" v-bind:class="{show : statusValue <= 2 , 'bg-grey' : statusValue > 2}" id="action_content_0">

                  <div class="d-none d-flex flex-wrap form-group">
                    <label class="col-12 col-md-6 col-form-label input-label">
                      Le dossier du porteur est-il complet ?
                    </label>

                    <div class="col-12 col-md-6 my-auto">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="aap[complet]" id="aap_complet_true" :checked="complet === true"
                               @change="set_complet()" :value="true">
                        <label class="form-check-label" for="aap_complet_true">
                          Oui
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="aap[complet]" id="aap_complet_false" :checked="complet === false"
                               @change="set_complet()" :value="false">
                        <label class="form-check-label" for="aap_complet_false">
                          Non
                        </label>
                      </div>

                      <button type="button" id="new_message" class="btn btn-primary pull-right"
                              data-tooltip="tooltip" title="Envoyer un message"
                              @click="notification_subject = `[ZeLink] - Votre projet ${aap.projet_nom} est incomplet`"
                              data-toggle="modal" data-target="#new_message_modal">
                        <span>
                            <i class="fa fa-plus" aria-hidden="true"></i> &nbsp;
                            Envoyer un message
                        </span>
                      </button>


<!--                      <div class="form-check form-check-inline">-->
<!--                        <a :href="'mailto:' + aap.contact_email" class="btn btn-sm btn-success">-->
<!--                          Envoyer un message-->
<!--                        </a>-->
<!--                      </div>-->

                    </div>
                  </div>

                  <div v-if="complet === false" class="form-group ml-3 mb-0">
                    <label for="raison_non_complet" class="col-form-label input-label">Si non, pourquoi ?</label>

                    <div class="">
                      <textarea rows="3" class="form-control" id="raison_non_complet" name="aap[raison_non_complet]" v-model="raison_non_complet"
                                placeholder="Raison ..." aria-label="Raison ..."></textarea>

                    </div>
                    <div v-if="error_non_complet_justification" class="text-danger">
                      Veuillez saisir la raison pour laquelle le dossier est incomplet.
                    </div>
                  </div>

                </div>

                <div v-if="statusValue > 1" class="card-header py-3"
                     v-bind:class="{show : statusValue == 3, 'bg-grey' : statusValue > 3}">
                  <h5 class="mb-0">
                    <button class="btn btn-link pl-0" style="font-size: 1rem !important;" @click="collapsed1 = !collapsed1"
                            data-toggle="collapse" data-target="#action_content_1" aria-expanded="true" aria-controls="action_content_1">
                      <i v-if="collapsed1" class="fa fa-plus pr-2" aria-hidden="true"></i>
                      <i v-else class="fa fa-minus pr-2" aria-hidden="true"></i>
                      Instruction
                    </button>
                  </h5>
                </div>

                <div class="collapse card-body px-2 py-3"
                     v-bind:class="{show : statusValue == 3, 'bg-grey' : statusValue > 3}" id="action_content_1" >

                  <div class="form-group ml-3 mb-0">
                    <label for="aap_raison_instruction" class="col-form-label input-label">Avis de l'instructeur</label>

                    <div class="">
                      <textarea rows="3" class="form-control" name="aap[raison_instruction]" id="aap_raison_instruction"
                                v-model="raison_instruction"
                                placeholder="Raison ..." aria-label="Raison ..."></textarea>
                    </div>
                  </div>

                  <div class="row form-group mt-4 ml-3">
                    <div class="col-sm-3 col-form-label input-label px-0">
                      <label for="montant_propose">
                        Montant proposé.
                      </label>
                      <small class="form-text text-primary">Montant global du projet : <strong class="text-success">{{ aap.budget_global }}</strong>.</small>
                      <small class="form-text text-primary">Montant demandé : <strong class="text-success">{{ aap.subvention_sollicitee }}</strong>.</small>
                    </div>

                    <div class="col-sm-9">
                      <div class="input-group px-0">
                        <input type="number" class="form-control" name="montant_propose" id="montant_propose" v-model="montant_propose"
                               placeholder="10000" aria-label="10000">
                        <div class="input-group-append">
                          <div class="input-group-text">€</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="statusValue > 3" class="card-header py-3"
                     v-bind:class="{'bg-grey' : statusValue > 4}">
                  <h5 class="mb-0">
                    <button class="btn btn-link pl-0" style="font-size: 1rem !important;"  @click="collapsed2 = !collapsed2"
                            data-toggle="collapse" data-target="#action_content_2" aria-expanded="true" aria-controls="action_content_2">
                      <i v-if="collapsed2" class="fa fa-plus pr-2" aria-hidden="true"></i>
                      <i v-else class="fa fa-minus pr-2" aria-hidden="true"></i>
                      Comité technique
                    </button>
                  </h5>
                </div>

                <div class="collapse card-body px-2 py-3" v-bind:class="{show : statusValue == 4, 'bg-grey' : statusValue > 4}" id="action_content_2">

                  <div class="ml-3">
                    <label class="col-form-label input-label">Résultat du comité</label>

                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="aap[avis_comite]" id="aap_avis_comite_1" v-model="avis_comite" value="Favorable">
                      <label class="form-check-label" for="aap_avis_comite_1">
                        Favorable
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="aap[avis_comite]" id="aap_avis_comite_2" v-model="avis_comite" value="Défavorable">
                      <label class="form-check-label" for="aap_avis_comite_2">
                        Défavorable
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="aap[avis_comite]" id="aap_avis_comite_3" v-model="avis_comite" value="Ajourné">
                      <label class="form-check-label" for="aap_avis_comite_3">
                        Ajourné
                      </label>
                    </div>
                  </div>

                  <div class="form-group ml-3 mb-0">
                    <label for="aap_raison_comite" class="col-form-label input-label">Avis du comité technique</label>

                    <div class="">
                      <textarea rows="3" class="form-control" name="aap[raison_comite]" id="aap_raison_comite"
                                placeholder="Raison ..." aria-label="Raison ..." v-model="raison_comite"></textarea>
                    </div>
                  </div>

                  <div class="row form-group mt-4 ml-3">
                    <label for="montant_decide" class="col-sm-3 col-form-label input-label px-0">Montant décidé <span
                        class="text-muted">(optionnel)</span></label>

                    <div class="col-sm-9">
                      <div class="input-group px-0">
                        <input type="number" class="form-control" name="montant_decide" id="montant_decide"
                               placeholder="10000" aria-label="10000" v-model="montant_decide">
                        <div class="input-group-append">
                          <div class="input-group-text">€ (HT)</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="statusValue > 3" class="card-header py-3">
                  <h5 class="mb-0">
                    <button class="btn btn-link pl-0" style="font-size: 1rem !important;" @click="collapsed3 = !collapsed3"
                            data-toggle="collapse" data-target="#action_content_3" aria-expanded="true" aria-controls="action_content_3">
                      <i v-if="collapsed3" class="fa fa-plus pr-2" aria-hidden="true"></i>
                      <i v-else class="fa fa-minus pr-2" aria-hidden="true"></i>
                      Commission
                    </button>
                  </h5>
                </div>

                <div class="collapse card-body px-2 py-3" v-bind:class="{show : statusValue == 5, 'bg-grey' : statusValue != 5}" id="action_content_3">

                  <div class="row form-group mt-4 ml-3">
                    <label for="aap_montant_attribue" class="col-sm-3 col-form-label input-label px-0">Montant attribué</label>

                    <div class="col-sm-9">
                      <div class="input-group px-0">
                        <input type="number" class="form-control" name="aap[montant_attribue]" id="aap_montant_attribue"
                               placeholder="10000" aria-label="10000" v-model="montant_attribue">
                        <div class="input-group-append">
                          <div class="input-group-text">€ (HT)</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer d-flex justify-content-end py-3">
                  <a v-if="statusValue < 5" class="btn btn-primary d-flex align-items-center" href="javascript:;" role="button"
                     @click="openStatusModal()">
                    <span>Valider cette étape</span>
                  </a>
                  <span v-else>

                    <span class="">Résultat --> </span>

                    <a class="btn btn-primary align-items-center" href="javascript:;" role="button" @click="set_ajourne">
                      <span>Ajourné</span>
                    </a>
                    <a class="btn btn-primary align-items-center" href="javascript:;" role="button" @click="set_rejete">
                      <span>Rejeté</span>
                    </a>
                    <a class="btn btn-primary align-items-center" href="javascript:;" role="button" @click="set_valide">
                      <span>Validé</span>
                    </a>



                  </span>
                </div>
              </div>
            </div>

            <!-- Sticky Block End Point -->
            <div id="stickyBlockEndPoint"></div>
          </div>

      </div>
    </div>

    <div v-if="admin" class="modal fade" id="changeStatusModal" tabindex="-1" role="dialog" aria-labelledby="changeStatusModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Validation</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="font-size-1">Êtes-vous sûr de valider le changement de statut :</p>
            <p class="font-size-1 font-weight-bold mb-0" id="status_validation"></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" data-dismiss="modal" @click="changeStatus()">Oui</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal">Non</button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>


export default {
  props: [
    'id',
  ],
  data: function () {
    return {
      message: "",
      message_type: "",
      wait_data: Boolean,

      admin: false,

      aap: Object,
      other_projects: Array,
      complet: false,
      raison_non_complet: "",
      raison_instruction: "",
      raison_comite: "",
      error_non_complet_justification: Boolean,

      statuses: Array,
      commissions: Array,
      comite_techniques: Array,
      // // charge_missions: Array,
      referents: Array,
      //Variable temporaire
      statusValue: 0,
      has_previous_proj: false,

      referent: {},
      // charge_mission: {},
      commission: {},
      comite_technique: {},
      avis_comite: "",

      montant_propose: 0,
      montant_alloue: 0,
      montant_decide: 0,
      montant_attribue: 0,

      collapsed: true,
      collapsed0: true,
      collapsed1: true,
      collapsed2: true,
      collapsed3: true,

      notification_subject: ""
    }
  },
  mounted() {
    this.wait_data = true
    this.error_non_complet_justification = false

    this.get_data()
  },

  filters: {
    truncate: function (data, num) {
      const reqdString =
          data.split("").slice(0, num).join("")
      return reqdString;
    }
  },

  watch: {
    statusValue: function(newVal, oldVal) {
      if( oldVal > 0) {
        this.set_status(this.id)
      }
    }
  },

  methods: {

    close_message: function () {
      this.message = null;
    },

    openStatusModal: function () {
      const _this = this
      let new_status = ''

      switch (_this.aap.status) {
        case 'Brouillon':
          new_status = 'Instruction'
          break;
        case 'Rempli':
          new_status = 'Instruction'
          break
        case 'Instruction':
          new_status = 'Comité technique'
          break
        case 'Comité':
          new_status = 'Commission'
          break
        case 'Commission':
          new_status = 'Validé'
          break
      }

      document.getElementById("status_validation").innerText =
          _this.aap.status + " → vers → " + new_status;
      $('#changeStatusModal').modal('show');
    },

    changeStatus: function () {

      const _this = this
      if (_this.statusValue == 1) {
        _this.statusValue = 3
      } else {
        this.statusValue++;
      }
    },

    set_ajourne: async function () {
      this.statusValue = 6
      this.montant_attribue = 0
    },

    set_rejete: async function () {
      this.statusValue = 8
      this.montant_attribue = 0
    },

    set_valide: async function () {
      this.statusValue = 9
    },

    set_status: async function (id) {

      const _this = this

      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/" + id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      // const form_element = new HTMLFormElement()
      const form_data = new FormData();
      form_data.append('aap[aap_status_histories_attributes][0][status_id]', _this.statusValue)
      form_data.append('aap[raison_non_complet]', _this.raison_non_complet)
      form_data.append('aap[raison_instruction]', _this.raison_instruction)
      form_data.append('aap[raison_comite]', _this.raison_comite)
      form_data.append('aap[montant_propose]', _this.montant_propose)
      form_data.append('aap[montant_decide]', _this.montant_decide)
      form_data.append('aap[montant_attribue]', _this.montant_attribue)


      if (_this.statusValue >= 4 ) {
        // const value = document.querySelector('input[name="aap[avis_comite]"]').value;
        form_data.append('aap[avis_comite]', _this.avis_comite)
      }


      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.get_data()
            _this.message = "Statut mis à jour"
            _this.message_type = "alert-success"
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );

    },

    get_statuses: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/statuses.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.statuses = response.data.statuses
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    set_complet: async function () {
      const _this = this;

      _this.wait_data = true
      const id = parseInt(_this.id, 10)

      const value = document.querySelector('input[name="aap[complet]"]:checked').value;
      const form_data = new FormData()
      form_data.append('aap[complet]', value)
      form_data.append('aap[raison_non_complet]', _this.raison_non_complet)

      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += `aaps/${id}.json`
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.get_aap()
            _this.message = "Projet mis à jour"
            _this.message_type = "alert-success"
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                _this.wait_data = false
              }
          );
    },

    get_comite_techniques: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/comite_techniques.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.comite_techniques = response.data.comite_techniques
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_commissions: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/commissions.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.commissions = response.data.commissions
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    // get_charge_missions: async function () {
    //   const _this = this;
    //   let [secure_key, customer_id, api_url, customer] = await get_token_2()
    //   api_url += "aaps/charge_missions.json"
    //   api_url += '?secure_key=' + secure_key
    //   api_url += '&customer_id=' + customer_id
    //
    //   _this.customer = customer
    //
    //   axios.get(api_url)
    //       .then(function (response) {
    //         _this.charge_missions = response.data.charge_missions
    //       })
    //       .catch(function (error) {
    //         console.log(error)
    //       })
    //       .then(function () {
    //             // always executed
    //           }
    //       );
    // },

    get_referents: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/referents.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.referents = response.data.referents
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_data: function () {
      this.get_statuses()
      this.get_referents()
      // this.get_charge_missions()
      this.get_commissions()
      this.get_comite_techniques()
      this.get_aap()
    },

    get_aap: function () {
      const _this = this;
      const id = parseInt(_this.id, 10)

      get_token_2().then(function (response) {
        let [secure_key, customer_id, api_url, customer, admin] = response

        _this.admin = admin
        if (admin == false) {
          _this.message = "Vous n'êtes pas autorisé à acceder à cette page"
          _this.message_type = "alert-danger"
        }

        api_url += `aaps/${id}.json`
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.get(api_url)
            .then(function (response) {
              _this.aap = response.data.aap
              _this.referent = _this.aap.referent
              // _this.charge_mission = _this.aap.charge_mission
              _this.commission = _this.aap.commission
              _this.comite_technique = _this.aap.comite_technique
              _this.complet = _this.aap.complet
              _this.raison_non_complet = _this.aap.raison_non_complet
              _this.raison_instruction = _this.aap.raison_instruction
              _this.raison_comite = _this.aap.raison_comite
              _this.montant_propose = _this.aap.montant_propose
              _this.montant_alloue = _this.aap.montant_alloue
              _this.montant_decide = _this.aap.montant_decide
              _this.montant_attribue = _this.aap.montant_attribue
              _this.avis_comite = _this.aap.avis_comite
              _this.statusValue = _this.aap.status_value

              if (_this.statusValue == 3) {
                _this.collapsed1 = false
              } else if (_this.statusValue == 4) {
                _this.collapsed2 = false
              }


              _this.wait_data = false
              get_token_2().then(function (response) {
                let [secure_key, customer_id, api_url, customer] = response
                api_url += `aaps.json`
                api_url += '?secure_key=' + secure_key
                api_url += '&customer_id=' + customer_id
                api_url += '&siret=' + _this.aap.siret

                axios.get(api_url)
                    .then(function (response) {
                      _this.other_projects = response.data.aaps
                    })
                    .catch(function (error) {
                      console.log(error)
                    })
                    .then(function () {
                          // always executed
                        }
                    );
              })
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );
      })

    },

    post_instruction: function (id) {
      const _this = this

      get_token_2().then(function (response) {

        let [secure_key, customer_id, api_url, customer] = response
        api_url += "aaps/" + id + ".json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id


        // const form_element = new HTMLFormElement()
        const form = document.getElementById('instruction_form')
        const form_data = new FormData(form);


        axios({
          method: 'patch',
          url: api_url,
          data: form_data
        })
            .then(function (response) {
              _this.get_data()
              _this.message = "Dossier mis à jour"
              _this.message_type = "alert-success"
              $('#modal_instruction').modal('hide')
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );

      })
    },

  },
}

</script>


<style scoped>

.bg-grey {
  background-color: #DCDCDC;
}

</style>

